function IconChevronDown({
  className,
  size = 16,
  color = '#1A1C1E',
  strokeWidth = 1.5,
}: {
  className?: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4 6L8 10L12 6"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

IconChevronDown.displayName = 'IconChevronDown';

export default IconChevronDown;
